var _a;
/**
 * 组件时间方向（从 useAiAssistant 抽出，避免共享 StoreDataLoader 依赖整页 AI Hook）
 */
import { StoreComponentType } from '../types/aiAssistantTypes';
var COMPONENT_TIME_DIRECTION = (_a = {},
    _a[StoreComponentType.STORE_OVERVIEW] = 'past',
    _a[StoreComponentType.ROOM_STATUS] = 'past',
    _a[StoreComponentType.ROOM_STATUS_RECENTLY] = 'past',
    _a[StoreComponentType.PRICE_ALERT] = 'past',
    _a);
export function getComponentTimeDirection(componentType) {
    var _a;
    return (_a = COMPONENT_TIME_DIRECTION[componentType]) !== null && _a !== void 0 ? _a : 'past';
}
